<script lang="ts" setup>
import { asInt,  sleep } from '@/utils';
import { computed, ref } from 'vue';
import { useTeaserStore } from '@/stores/teaser';
import { useUserStore } from '@/stores/user';
import { performerStatusColor } from '@/api/performer/utils';
import { useRouter, useRoute } from 'vue-router';
import { usePerformerStore } from '@/stores/performer';
import Spinner from '@/components/grid/spinner/spinner.vue';

import player from '@/components/video/player.vue';


const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const performerStore = usePerformerStore();

const audio = ref('off');
const props = withDefaults(
    defineProps<{ tile: any, colums: string, type?: string }>(),{}
);

const teaserStore = useTeaserStore();
const performer = computed(() => {
    return props.tile ? performerStore.getById(props.tile.performer) : undefined;
});

const isMobile = computed(() => userStore.isMobile());

async function swap(performerId: number) {
    const performer = performerStore.getById(performerId) as any;
    if(!performer){ return; }
    
    try {
        // Added for management
        await sleep(1000);
        await teaserStore.swap(performerId);
        router.replace({ name: 'teaser', params: { advert: performer.advertNumber} });
    } catch {
        return;
    }
}
</script>

<template src="./tile-teaser.html"></template>

<style lang="scss">
@import './tile.scss';
</style>
